export const useFavoriteMenus = () => {
  const { $api } = useNuxtApp()

  return {
    fetchFavoriteIds: () =>
      $api.get<{ data: number[] }>('/api/v1/me/menus/favorites'),

    addFavorite: (menuId: number) =>
      $api.post(`/api/v1/me/menus/${menuId}/favorite`),

    removeFavorite: (menuId: number) =>
      $api.delete(`/api/v1/me/menus/${menuId}/favorite`),
  }
}
